export const pagination = {
  data () {
    return {
      pagination: new this.$pagination({
        count: '',
        currentPage: ''
      })
    }
  },
  mounted () {
    if (this.getInStart === false) {
      return
    }
    this.start()
  },
  methods: {
    start () {
      this.$send.submit(this.type || 'get', this.url, this[this.what] || '')
        .then(response => {
          this.data = response.data
          this.pagination.change(
            response.current_page,
            response.last_page
          )
        })
    },
    page (num) {
      if (num === this.pagination.currentPage || num === '...') {
        return
      }
      this.$send.submit(this.type || 'get', this.url + '?page=' + num, this[this.what] || '')
        .then(response => {
          this.pagination.change(
            response.current_page,
            response.last_page
          )
          this.data = response.data
        })
    }
  }
}
export default pagination
